/**
 * Created by Carsten Bühler
 * User: c.buehler on 21.11.2018
 * Copyright: xdot GmbH 2018
 */

'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';

import { FormControl, FormGroup, FormLabel } from 'external/react-bootstrap';
import { AmdRequireComponent, Title, ValidationMessage } from 'plugin/liferay-widgets-react-web';

const OPTIONS = [
  { key: 'Group', label: 'Alarmstufe (Mandant)' },
  { key: 'DikeBreak', label: 'Deichbruchszenario' },
  { key: 'ManualBooleanState', label: 'Ereignis' },
  { key: 'FloodRetentionBasin', label: 'Hochwasserrückhaltebecken' },
  { key: 'CriticalObject', label: 'Kritisches Objekt' },
  { key: 'NewsMessage', label: 'Lagemeldung' },
  { key: 'Task', label: 'Maßnahmen in Ausführung' },
  { key: 'RealPrecipitationStation', label: 'Niederschlagsmessstation' },
  { key: 'PrecipitationStation', label: 'Radar Niederschlagsmessung' },
  { key: 'GaugingStation', label: 'Pegel' },
  { key: 'Quarter', label: 'Teilgebiet' },
];

class AssetLinkChooser extends React.Component {

  constructor(props) {
    super(props);
    this.onObjectTypeChange = this.onObjectTypeChange.bind(this);
    this.onAssetSelected = this.onAssetSelected.bind(this);
    this.state = {
      objectType: this.props.objectType,
    };
    this.props.onChange(this.props.formData, this.validate(this.props.formData));
  }

  onObjectTypeChange(event) {
    this.setState({
      objectType: event.target.value
    });
  }

  onAssetSelected(formData) {
    this.props.onChange(formData, this.validate(formData));
  }

  validate(formData) {
    let idValid;

    if (!(formData.id > 0) || !(formData.className)) {
      idValid = 'Bitte Asset auswählen';
    }

    return {
      id: idValid
    };
  }

  render() {
    const { filterTypes, hideTypes } = this.props;
    return (
      <fieldset className="padding-box">
        <Title title="Welches Objekt soll verknüpft werden?"/>
        <FormGroup controlId="AssetLinChooserObjectTypeChooser">
          <FormLabel>
            Objekttyp
          </FormLabel>
          {' '}
          <FormControl
            as="select"
            required
            value={this.state.objectType}
            onChange={this.onObjectTypeChange}
          >
            <option value="">Bitte wählen</option>
            {
              OPTIONS
                .filter(o => {
                  if (filterTypes) {
                    return filterTypes.includes(o.key);
                  } else if (hideTypes) {
                    return !hideTypes.includes(o.key);
                  }
                  return true;
                })
                .map(o => (
                  <option key={o.key} value={o.key}>{o.label}</option>
                ))
            }

          </FormControl>
          <ValidationMessage formValidation={this.props.formValidation} propName="id"/>
        </FormGroup>
        {
          this.state.objectType &&
          <div>
            <AmdRequireComponent dependencies={[ 'FliwasObjectChooser/' + this.state.objectType ]}>
              {(Renderer) => <Renderer formData={this.props.formData} onChange={this.onAssetSelected}/>}
            </AmdRequireComponent>
            <ValidationMessage formValidation={this.props.formValidation} propName="id"/>
          </div>
        }

      </fieldset>

    );
  }
}

AssetLinkChooser.propTypes = {
  onChange: PropTypes.func,
  formData: PropTypes.object,
  formValidation: PropTypes.object,
  objectType: PropTypes.string,
  filterTypes: PropTypes.arrayOf(PropTypes.string),
  hideTypes: PropTypes.arrayOf(PropTypes.string),
};

export default AssetLinkChooser;



// WEBPACK FOOTER //
// ./js/components/AssetLinkChooser.jsx